<template>
  <b-container>
    <h4>Titel:</h4>
    <b-form-input v-model="warning.title"></b-form-input>
    <hr class="mt-4 mb-4">
    <h4>Inhalt:</h4>
    <trumbowyg v-model="warning.content" :config="config" class="form-control" name="content"/>

    <h4>Farbe:</h4>
    <b-form-radio-group
        v-model="warning.color"
        :options="colors"
        stacked
    >
    </b-form-radio-group>


    <h4>Aktiv:</h4>
    <b-form-radio v-model="warning.public" name="some-radios" value="1">An</b-form-radio>
    <b-form-radio v-model="warning.public" name="some-radios" value="0">Aus</b-form-radio>
    <hr class="mt-4 mb-4">
    <b-button v-if="create" variant="outline-success" block @click="submitCreateWarning()"
              style="margin-top: 10px; margin-bottom: 10px;">Erstellen
    </b-button>
    <b-button v-if="!create" variant="outline-success" block @click="storeWarning(warning)"
              style="margin-top: 10px; margin-bottom: 10px;">Speichern
    </b-button>
  </b-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import 'jquery-resizable-dom';
import '@/trumbowyg.multiupload';
import '@/trumbowyg.table';
import '@/trumbowyg.fontsize'
import '@/trumbowyg.resizimg';
import helpers from "@/helpers";

export default {
  name: "WarningEdit",
  props: {
    create: Boolean
  },
  data() {
    return {
      warningId: parseInt(this.$route.params.warningId),
      config: {
        tagsToRemove: ['script'],
        lang: 'de',
        imageWidthModalEdit: true,
        disabled() {
          return this.article === undefined;
        },
        btns: [
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting', 'fontsize', 'horizontalRule'],
          ['strong', 'em', 'del', 'removeformat'],
          ['link', 'multiupload', 'table'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['fullscreen'],
        ],
        plugins: {
          multiupload: {
            apiUrl: process.env.VUE_APP_API_URL + '/file',
            authToken: `${this.authToken}`
          },
          fontsize: {
            sizeList: [
              '11px',
              '12px',
              '14px'
            ],
            allowCustomSize: true
          }
        }
        // https://alex-d.github.io/Trumbowyg/documentation
      },
      colors: [
        {
          html: '<span style="background-color: #dc3545" class="colorOption">Rot</span>',
          value: '#dc3545'
        },
        {
          html: '<span style="background-color: #28a745" class="colorOption">Grün</span>',
          value: '#28a745'
        },
        {
          html: '<span style="background-color: #007bff" class="colorOption">Blau</span>',
          value: '#007bff'
        },
        {
          html: '<span style="background-color: #ffc107" class="colorOption">Gelb</span>',
          value: '#ffc107'
        },
        {
          html: '<span style="background-color: #6f42c1" class="colorOption">Lila</span>',
          value: '#6f42c1'
        },
        {
          html: '<span style="background-color: #e83e8c" class="colorOption">Pink</span>',
          value: '#e83e8c'
        },
        {
          html: '<span style="background-color: #fd7e14" class="colorOption">Orange</span>',
          value: '#fd7e14'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getStoredWarningById',
      'getNewWarning',
      'getStoredWarnings',
    ]),
    warning() {
      if (this.create) return this.getNewWarning
      let warning = this.getStoredWarningById(this.warningId)
      if(warning === undefined) {
        return {}
      }
      return warning
    },
    disabled() {
      return this.warning.description === undefined
    }
  },
  mounted() {
    if (!this.create) this.getWarnings()
  },
  methods: {
    ...mapActions([
      'getWarnings',
      'storeWarning',
      'createWarning',
    ]),
    submitCreateWarning() {
      this.createWarning(this.warning).then(() => {
        helpers.handleSuccessMessage("Der Hinweis wurde erstellt.", "Erstellt")
        this.$router.push('/Hinweise')
      })
    }
  }
}
</script>

<style>
.colorOption {
  color: white;
  padding: 2px 8px;
  border-radius: 2px;
  min-width: 8ch;
  position: absolute;
  text-align: center;
  margin: 4px 0;
}


.custom-control {
  height: 36px;
  display: flex;
}

.custom-control-label:before {
  top: 0.6rem
}

.custom-control-label:after {
  top: 0.6rem
}
</style>
